<template>
  <div>
    <SiteHeader :appLoginUrl="appLoginUrl" />

    <div class="section hero-wrap">
      <div class="container">
        <HeroSection :appLoginUrl="appLoginUrl" :whatsAppUrl="whatsAppUrl" />
      </div>
    </div>

    <section class="section">
      <div class="container reveal">
        <PainPointsSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <SolutionSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <BenefitsSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <FeaturesSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <CompetitiveSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <PlansSection />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <CTASection :appLoginUrl="appLoginUrl" :whatsAppUrl="whatsAppUrl" />
      </div>
    </section>

    <section class="section">
      <div class="container reveal">
        <TrustSection />
      </div>
    </section>

    <footer class="footer-wrap">
      <div class="container reveal footer-container">
        <FooterSection :appLoginUrl="appLoginUrl" />
      </div>
    </footer>

    <a
      v-if="whatsAppUrl"
      class="whatsapp-fab"
      :href="whatsAppUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
    >
      <span class="whatsapp-icon" aria-hidden="true">💬</span>
      <span class="whatsapp-text">WhatsApp</span>
    </a>
  </div>
</template>

<script>
import HeroSection from '../components/HeroSection.vue'
import PainPointsSection from '../components/PainPointsSection.vue'
import SolutionSection from '../components/SolutionSection.vue'
import BenefitsSection from '../components/BenefitsSection.vue'
import FeaturesSection from '../components/FeaturesSection.vue'
import CompetitiveSection from '../components/CompetitiveSection.vue'
import PlansSection from '../components/PlansSection.vue'
import CTASection from '../components/CTASection.vue'
import TrustSection from '../components/TrustSection.vue'
import FooterSection from '../components/FooterSection.vue'
import SiteHeader from '../components/SiteHeader.vue'

const DEFAULT_APP_LOGIN_URL = 'https://app.easysaude.click'

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    PainPointsSection,
    SolutionSection,
    BenefitsSection,
    FeaturesSection,
    CompetitiveSection,
    PlansSection,
    CTASection,
    TrustSection,
    FooterSection,
    SiteHeader
  },
  data() {
    return {
      appLoginUrl: process.env.VUE_APP_APP_LOGIN_URL || DEFAULT_APP_LOGIN_URL,
      whatsAppUrl: process.env.VUE_APP_WHATSAPP_URL || ''
    }
  },
  mounted() {
    document.title = 'EasySaúde | Gestão para clínicas'

    const elements = Array.from(document.querySelectorAll('.reveal'))
    if (!('IntersectionObserver' in window) || elements.length === 0) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.12 }
    )

    elements.forEach((el) => observer.observe(el))
  }
}
</script>

<style>
.hero-wrap {
  padding-top: 32px;
  background: radial-gradient(900px 420px at 20% 0%, rgba(77, 186, 135, 0.18) 0%, rgba(77, 186, 135, 0) 60%),
    linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.02) 100%);
}

.footer-wrap {
  padding: 20px 0 10px;
}

.footer-container {
  width: 100%;
  max-width: 1120px;
}

.whatsapp-fab {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 9999;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 999px;
  background: #25d366;
  color: #fff;
  text-decoration: none;
  box-shadow: 0 18px 40px rgba(37, 211, 102, 0.35);
  transition: transform 140ms ease, box-shadow 140ms ease;
}

.whatsapp-fab:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 50px rgba(37, 211, 102, 0.45);
}

.whatsapp-text {
  font-weight: 800;
}

@media (max-width: 720px) {
  .whatsapp-text {
    display: none;
  }
}
</style>
